import React from 'react'
import { Card, Separator, Button, Text, XStack, YStack, styled } from '@red-ui/components'
import { getString } from '@vrw/data'
import { getTrackingId } from '../../helpers/getTrackingId'
import { formatPoints } from '@vrw/data/src/utils/formatters'
import { SeatTypeInfo } from './SeatTypeInfo'
import { CURRENCY_SYMBOLS, Fare } from '../../api/searchFlights'

type Props = Fare & {
  onSelect: () => void
  expanded: boolean
  onExpand: (isOpen: boolean) => void
}

const PriceRow = styled(XStack, {
  justifyContent: 'space-between',
  $gtMobile: { flexDirection: 'column', alignItems: 'flex-start' },
  $gtTabletLandscape: { flexDirection: 'row', alignItems: 'flex-end' },
})

const PriceText = styled(Text, {
  fontSize: '$3',
  $gtMobile: { fontSize: '$5' },
  $gtTabletLandscape: { fontSize: '$6' },
})

export const SeatTypeCard = ({ onSelect, expanded, onExpand, id, price, availability, fareFamilyType }: Props) => {
  const { awardPoints, currency, amountIncludingTax } = price ?? {}

  return (
    <Card
      minWidth={284}
      flexGrow={1}
      flexBasis="0%"
      backgroundColor="$white"
      borderWidth={1}
      borderColor="$black2"
      padding="$2"
      marginRight="$2"
      $gtMobile={{ padding: '$3', marginRight: '$3', minWidth: 254 }}>
      {!availability && id ? (
        <YStack justifyContent="space-between" flex={1}>
          <YStack>
            <SeatTypeInfo id={id} expanded={expanded} onExpand={onExpand} />
          </YStack>
          <YStack>
            <Separator marginVertical="$2" $gtMobile={{ marginVertical: '$3' }} />
            <YStack gap="$1">
              <PriceRow>
                <PriceText>{getString('misc.virginPoints')}</PriceText>
                <strong>
                  <Text lineHeight="$7" fontSize="$7" $gtMobile={{ fontSize: '$8' }} $gtTabletLandscape={{ fontSize: '$9' }}>
                    {formatPoints({ points: Number(awardPoints) })}
                  </Text>
                </strong>
              </PriceRow>
              {currency && amountIncludingTax && (
                <PriceRow>
                  <PriceText>{getString('redSkySearch.results.card.tax')}</PriceText>
                  <PriceText>{`${CURRENCY_SYMBOLS[currency]}${amountIncludingTax.toFixed(2)}`}</PriceText>
                </PriceRow>
              )}
            </YStack>
            <Button
              id={getTrackingId('flight-card', getString('redSkySearch.results.card.cta'))}
              height="$6"
              onPress={onSelect}
              aria-label={getString('redSkySearch.results.card.cta')}
              marginTop="$3">
              {getString('redSkySearch.results.card.cta')}
            </Button>
          </YStack>
        </YStack>
      ) : (
        <>
          <Text fontWeight="600" fontSize="$4" $gtMobile={{ fontSize: '$7' }} marginBottom="$3">
            {getString(`redSkySearch.results.card.fare.family.${fareFamilyType.toLowerCase()}`)}
          </Text>
          <Text>{getString(`redSkySearch.results.card.fare.unavailable`)}</Text>
        </>
      )}
    </Card>
  )
}
